import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Feedback } from './usability-onderzoek.model';

@Injectable({ providedIn: 'root' })
export class UsabilityOnderzoekResource {
    private readonly baseUrl: string = '/services/apic-usability-onderzoek/api';

    constructor(private readonly httpClient: HttpClient) {}

    public creeerFeedback(feedback: Feedback): Observable<void> {
        return this.httpClient.post<void>(`${this.baseUrl}/feedback`, feedback);
    }
}
